import styled from 'styled-components';
import { Wrapper, Container, Content, Backdrop } from '../Modal/Modal.styles';

export const MobileContainer = styled(Container)`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: block;
  }
`;
export const MobileContent = styled(Content)`
  width: auto;
`;
export const MobileBackdrop = styled(Backdrop)`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: block;
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  padding: 5vh;
  background: ${({ theme }) => theme.colors.functional.white};
  position: fixed;
  top: 5vh;
  left: 5vh;
  right: 5vh;
  bottom: 5vh;
  z-index: ${({ theme }) => theme.zIndex.backdrop + 1};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  box-shadow: ${({ theme }) => theme.boxShadow.blue};
  button {
    padding: 2rem 0;
    white-space: nowrap;
    display: flex;
    align-items: center;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary.main};
    fill: ${({ theme }) => theme.colors.primary.main};
    & > span {
      display: flex;
      svg {
        margin-right: 1rem;
        width: 2.4rem;
        height: 2.4rem;
        transform: rotate(180deg);
      }
    }
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    display: block;
  }
`;
